import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import { useSelector, useDispatch } from 'react-redux';
import { StyledListBody } from './StyledTypeComponent';
import { pushSelectedCheckList, pushSelectedChipArray } from '../../slices/customQueryBodySlice';

const TypeComponent = () => {
  const dispatch = useDispatch();
  const queryStringArray = useSelector(state => state.customQueryBody.queryStringArray);
  let checkedArray = ['High', 'VeryHigh', 'Medium', 'Low'];

  const onCheckBoxClick = event => {
    let newArray = [];

    if (queryStringArray[2] && queryStringArray[2].length > 0) {
      newArray = newArray.concat(queryStringArray[2]);
    }

    if (event.target.checked) {
      newArray.push(event.target.name);
    }

    if (!event.target.checked) {
      let formedNewArray = newArray.filter(existingItem => {
        return existingItem !== event.target.name;
      });
      newArray = formedNewArray;
    }

    let chipArray = [];
    newArray.forEach(eachEle => {
      chipArray.push(queryStringArray[0] + ' ' + queryStringArray[1] + ' ' + eachEle);
    });
    checkedArray.push(event.target.name);
    dispatch(pushSelectedCheckList(newArray));
    dispatch(pushSelectedChipArray(chipArray));
  };

  let riskTypes = [{
    dataKey: 'Very High',
    dataChecked: false
  }, {
    dataKey: 'High',
    dataChecked: false
  }, {
    dataKey: 'Medium',
    dataChecked: false
  }, {
    dataKey: 'Low',
    dataChecked: false
  }];
  return /*#__PURE__*/React.createElement(StyledListBody, null, riskTypes.map((riskTpe, index) => {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: index
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(Checkbox, {
      name: riskTpe.dataKey,
      id: `${riskTpe.dataKey}${index}`,
      onChange: onCheckBoxClick,
      color: "primary"
    })), /*#__PURE__*/React.createElement(ListItemText, {
      id: riskTpe.dataKey,
      primary: riskTpe.dataKey
    }));
  }));
};

export default TypeComponent;